import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { CommonModule } from '@angular/common';
import { MatRadioModule } from "@angular/material/radio";
import { FieldResource } from "../../core/modules/openapi";

@Component({
  selector: "app-radiobutton",
  imports: [MatFormFieldModule, MatRadioModule, ReactiveFormsModule, CommonModule],
  template: `
    <div class="demo-full-width margin-top" [formGroup]="group">
      <label class="radio-label-padding">{{ field.displayName }}:</label>
      <mat-radio-group [formControlName]="field.name">
        <mat-radio-button *ngFor="let item of field.possibleValues" [value]="item">{{ item }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  `,
  standalone: true,
  styles: []
})
export class RadiobuttonComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
